module.exports = __webpack_public_path__ + "img/genswell_main.6b6533cf.png";